var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-8" }, [
          _c("h5", { staticClass: "card-title" }, [
            _c(
              "a",
              {
                staticClass: "text-dark",
                attrs: {
                  href: _vm.base_url + "pro/cotizacion_invitado/" + _vm.s.id_mm,
                },
              },
              [
                _vm._v(
                  "\n            Mudanza " +
                    _vm._s(_vm.s.ambito) +
                    " de " +
                    _vm._s(_vm.s.m3) +
                    "m"
                ),
                _c("sup", [_vm._v("3")]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-10" }, [
              _c("span", { staticClass: "text-muted" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(
                      _vm.moment(_vm.s.fecha_requerida).format("DD/MM/YYYY")
                    ) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _vm.s.fecha_requerida == _vm.moment().format("YYYY-MM-DD")
                ? _c("span", { staticClass: "text-muted" }, [
                    _vm._v("para hoy"),
                  ])
                : _c("span", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.moment(_vm.s.fecha_requerida).fromNow())),
                  ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-10" }, [
              _vm.s.inmueble_origen
                ? _c("em", { staticClass: "text-primary" }, [
                    _vm._v(_vm._s(_vm.s.inmueble_origen.descripcion)),
                  ])
                : _vm._e(),
              _vm._v(
                " -\n            " + _vm._s(_vm.s.dir_origen) + "\n          "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-10" }, [
              _vm.s.inmueble_destino
                ? _c("em", { staticClass: "text-primary" }, [
                    _vm._v(_vm._s(_vm.s.inmueble_destino.descripcion)),
                  ])
                : _vm._e(),
              _vm._v(
                " -\n            " + _vm._s(_vm.s.dir_destino) + "\n          "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-10" }, [
              _c("span", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.s.id_mm)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-2" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-10" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _vm.s.descuento_solicitud.precio_promocion > 0
                    ? _c(
                        "span",
                        {
                          staticClass: "badge badge-danger",
                          attrs: {
                            title:
                              "Nuestras asesoras no han tenido contacto con el cliente, aprovecha el descuento de preventa",
                          },
                        },
                        [
                          _vm._v(
                            "\n                  Pre-Venta\n                "
                          ),
                        ]
                      )
                    : _c(
                        "span",
                        {
                          staticClass: "badge badge-success",
                          attrs: {
                            title:
                              "Nuestras asesoras ya han tenido contacto con el cliente y verificado la solciitud",
                          },
                        },
                        [
                          _vm._v(
                            "\n                  Cliente verificado\n                "
                          ),
                        ]
                      ),
                  _vm._v(" "),
                  _vm.s.cliente_frecuente && _vm.s.cliente_frecuente.correo
                    ? _c(
                        "span",
                        {
                          staticClass: "badge badge-warning",
                          attrs: {
                            title:
                              "Este cliente ha contratado en el pasado con Mejores Mudanzas",
                          },
                        },
                        [
                          _vm._v(
                            "\n                  Cliente frecuente\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.s.via_contacto == "landing_pages_compartidas"
                    ? _c(
                        "span",
                        {
                          staticClass: "badge",
                          staticStyle: {
                            background: "#7022b3",
                            color: "white",
                          },
                          attrs: {
                            title:
                              "Este cliente se interesa en un servicio de mudanza compartida",
                          },
                        },
                        [_vm._v("Compartida")]
                      )
                    : _vm.s.via_contacto == "landing_pages_economicas"
                    ? _c(
                        "span",
                        {
                          staticClass: "badge badge-info",
                          attrs: {
                            title:
                              "Este cliente se interesa en un servicio de mudanza economica",
                          },
                        },
                        [
                          _vm._v(
                            "\n                  Económica\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.s.numero_cotizaciones == 0
                    ? _c(
                        "span",
                        {
                          staticClass: "badge badge-info",
                          attrs: {
                            title:
                              "Se el primero en cotizar y ganate a este cliente que aún no recibe cotizaciones",
                          },
                        },
                        [
                          _vm._v(
                            "\n                  Ser el primero\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "span",
                    { staticClass: "small", staticStyle: { color: "#9b9b9b" } },
                    [
                      _vm._v(
                        "\n                  Publicada\n                  " +
                          _vm._s(_vm.moment(_vm.s.fecha_liberacion).fromNow()) +
                          "\n                "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4 text-center" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-warning text-white",
              attrs: {
                href: _vm.base_url + "pro/cotizacion_invitado/" + _vm.s.id_mm,
              },
            },
            [
              _vm._v("\n          Ver detalles\n          "),
              _c("i", { staticClass: "fas fa-angle-right" }),
            ]
          ),
          _vm._v(" "),
          _c(
            "h5",
            {
              staticClass: "display-4 mt-4",
              staticStyle: { "font-size": "2.25rem" },
            },
            [
              _vm._v("\n          $\n          "),
              _vm.s.descuento_solicitud.precio_promocion > 0
                ? _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.s.descuento_solicitud.precio_promocion) +
                        "\n          "
                    ),
                  ])
                : _c("span", [_vm._v(_vm._s(_vm.s.precio_m4))]),
              _vm._v(" "),
              _c("span", { staticStyle: { "font-size": "18px" } }, [
                _vm._v(" MXN"),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.s.descuento_solicitud.precio_promocion > 0
            ? _c(
                "span",
                {
                  staticClass: "display-4 mt-4",
                  staticStyle: {
                    "font-size": "1.25rem",
                    "text-decoration": "line-through",
                  },
                },
                [
                  _vm._v(
                    "\n          $" + _vm._s(_vm.s.precio_m4) + " MXN\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
        ]),
      ]),
      _vm._v(" "),
      _vm.s.preocupacion_cliente
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 mt-3" }, [
              _c(
                "div",
                {
                  staticClass: "alert alert-warning m-0",
                  attrs: { role: "alert" },
                },
                [
                  _c("ul", { staticClass: "list-unstyled mb-0" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c("li", [
                      _c("small", [_vm._v(_vm._s(_vm.s.preocupacion_cliente))]),
                    ]),
                  ]),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-2" }, [
      _c("span", { staticClass: "text-info" }, [_c("b", [_vm._v("Para: ")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-2 text-info" }, [
      _c("b", [_vm._v("De:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-2 text-info" }, [
      _c("b", [_vm._v("Hacia:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-2 text-info" }, [
      _c("b", [_vm._v("ID:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("b", [_vm._v("Nota importante")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }